import { render, staticRenderFns } from "./profitsResults.vue?vue&type=template&id=738a173c"
import script from "./profitsResults.vue?vue&type=script&lang=js"
export * from "./profitsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports